import Typography from '@/components/ui/typography';
import { SearchX } from 'lucide-react';

const NoResult = ({ kind }: { kind: string }) => {
  return (
    <div className="py-16 flex flex-col items-center justify-center space-y-4">
      <SearchX size={96} />
      <Typography.H2 className="text-center">No {kind} Found</Typography.H2>
    </div>
  );
};

export default NoResult;
